<template>
	<div>
  	<!-- Ponderación -->
		<v-card class="elevation-0 shadowCard">
			<v-card-title primary-title>
        <v-spacer></v-spacer>
        <v-avatar
          size="45"
          color="transparent"
          rounded
          class="elevation-1 avatares shadowCard"
        >
          <v-icon color="white">mdi-lead-pencil</v-icon>
        </v-avatar>
        <v-spacer></v-spacer>
			</v-card-title>
			<v-card-text>
				<div>
          <p class="mb-0 font-weight-bold text-body-1">
          	Exámenes
          </p>
          <h5 class="mb-1 font-weight-bold text-body-1 colorCurso" >
            {{ getGrupo.ponderacion.valor_examenes }}
          </h5>

          <p class="mb-0 font-weight-bold text-body-1">
          	Ejercicios
          </p>
          <h5 class="mb-1 font-weight-bold text-body-1 colorCurso" >
            {{ getGrupo.ponderacion.valor_ejercicios }}
          </h5>

          <p class="mb-0 font-weight-bold text-body-1">
          	Participación
          </p>
          <h5 class="mb-1 font-weight-bold text-body-1 colorCurso" >
            {{ getGrupo.ponderacion.valor_asistencias }}
          </h5>

          <p class="mb-0 font-weight-bold text-body-1">
          	Total
          </p>
          <h5 class="mb-1 font-weight-bold text-body-1 colorCurso" >
            {{ getGrupo.ponderacion.valor_total }}
          </h5>

        </div>
			</v-card-text>
		</v-card>
	</div>
</template>
<script>
	// importar librerías
	import { mapGetters, mapActions } from 'vuex'

	// Componentes
  import Alerta     from '@/components/alertas/Alerta.vue'
  import Loader     from '@/components/alertas/Loader.vue'
  
  import Teachers   from '@/components/grupos/Teachers.vue'


	export default {
	  computed:{
	  	...mapGetters( 'login', [ 'getGrupo', 'getUsuarioLMS' ])
	  },
	};
</script>

<style scoped>
	.avatares{
		background-image: linear-gradient(310deg, #2152ff 0%, #21d4fd 100%);
	}

	.shadowCard{
		border-radius: 15px !important; 
		box-shadow: 0 20px 27px 0 rgba(0,0,0,0.1)  !important;
	}

	.recursos{
		background: rgb(233,186,255);
		background: linear-gradient(90deg, rgba(233,186,255,1) 0%, rgba(186,52,251,1) 100%);
	}

	.calificaciones{
		background-image: linear-gradient(310deg, #2152ff 0%, #21d4fd 100%);
	}

	.colorCurso{
		color: #006093;
	}

</style>
